import TabOrderDetails from './TabOrderGeneral';

export default TabOrderDetails;
